import React from 'react';
import { NCZIElement } from '../../../../../Interfaces/ncziTypes';
import NZCIListItem from '../../../../Base/NZCIListItem';
// @ts-ignore
import styles from './EHRElement.module.scss';
import FormattedDate, { FormattedDateTime, FormattedNcziTime } from '../../../../../../../Components/FormattedDate';
import EHRElementExtension from './EHRElementExtension';
import useTranslation from '../../../../../../../Hooks/useTranslation';

interface Props {
	element: NCZIElement | undefined;
}

const EHRElement: React.FC<Props> = props => {
	const { element } = props;
	const {t} = useTranslation();

	if (!element) {
		return <></>;
	}

	let elementValue: any = element.value;
	if(element.type === 'TS') {
		if(['CEN-EN13606-ENTRY.PotvrdenieDocasnejPraceneschopnosti.v1/at0022', 'CEN-EN13606-ENTRY.PotvrdenieDocasnejPraceneschopnosti.v1/at0025'].indexOf(element.archetypeId) !== -1) {
			elementValue = <FormattedNcziTime datetime={element.value} />;
		} else {
			elementValue = <FormattedDateTime datetime={element.value} />;
		}
	} else if (element.type === 'DATE') {
		elementValue = <FormattedDate date={element.value} />;
	} else if (element.type === 'BL') {
		elementValue = t(element.value === 'true' ? 'base.yes' : 'base.no');
	} else if (element.type === 'II') {
		elementValue = <EHRElementExtension element={element} />;
	}

	return (
		<div className={styles.wrapper}>
			<NZCIListItem
				title={element.name}
				value={elementValue}
				// extra={element.archetypeId}
			/>
		</div>
	);
};

export default EHRElement;
